
import { Component, Vue, Watch } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import Themeable from 'vuetify/lib/mixins/themeable';
import WebsiteRepositoryInterface, { Website } from '../../../services/Website/interfaces';
import { ServerInterface, ServerRepositoryInterface } from '@/services/Server/Interfaces';

@Component({
  mixins: [Themeable],
  inject: [
    'websiteRepository',
    'serverRepository',
  ],
})
export default class AllWebsites extends Vue {
  public loading: boolean = true;

  private websiteRepository!: WebsiteRepositoryInterface;

  private serverRepository!: ServerRepositoryInterface;

  public options: { page: number, itemsPerPage: number } = {
    page: 1,
    itemsPerPage: 10,
  };

  public totalWebsitesCount = 10;

  public headers: DataTableHeader[] = [
    { text: 'Id', value: 'id' },
    { text: 'Domain', value: 'domain' },
    { text: 'Server', value: 'originServer' },
    { text: 'Status', value: 'status' },
  ];

  public websiteStatuses: string[] = [
    'PENDING',
    'DISABLED',
    'ACTIVE',
    'ERROR',
  ];

  public tableSearch: string = '';
  public websiteSearch: string = '';
  public websites: Website[] = [];

  public serversMap: { [id: string]: string } = {};

  public async created(): Promise<void> {
    this.loading = true;
    try {
      await this.loadWebsites();
    } catch (err) {
      this.$errorDialog.show('An issue occurred while retrieving websites.');
    } finally {
      this.loading = false;
    }
  }

  public async loadWebsites(): Promise<void> {
    let searchParams = [this.websiteSearch, undefined, undefined];
    if (this.websiteSearch && this.websiteStatuses.includes(this.websiteSearch.toUpperCase())) {
      searchParams = [undefined, undefined, this.websiteSearch];
    }

    const response = await this.websiteRepository.searchWebsites(this.options.page, ...searchParams);
    const serversIds = response.Websites.map((website: Website) => website.originServer);

    const newServers: string[] = [];
    serversIds.forEach((serverId: string) => {
      if (this.serversMap[serverId]) {
        return;
      }

      newServers.push(serverId);
    })

    if (newServers.length > 0) {
      const servers = await this.serverRepository.getServersByIds(newServers);
      servers.forEach((server: ServerInterface) => {
        this.serversMap[server._id] = server.hostname;
      })
    }

    this.websites = response.Websites;
    this.totalWebsitesCount = response.count;

  }

  @Watch('websiteSearch')
  public watchSearch(): void {
    this.options.page = 1;
  }

  public createWebsite(): void {
    this.$router.push({ name: 'website_create' });
  }
}
